exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-box[data-v-5de10cb5] {\n  display: block;\n  height: 100%;\n  width: 100%;\n}\n.table-box tr[data-v-5de10cb5] {\n    display: table;\n    width: 100%;\n}\n.table-box tr td[data-v-5de10cb5] {\n      padding: 8px;\n      height: auto;\n      min-height: 36px;\n}\n.table-th[data-v-5de10cb5] {\n  padding: 2px 8px;\n  text-align: center;\n  vertical-align: middle;\n  border: solid thin #ccc;\n  font-size: 14px;\n}\n.clickable[data-v-5de10cb5] {\n  cursor: pointer;\n  text-decoration: underline;\n}\n.line-feed[data-v-5de10cb5] {\n  white-space: pre;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5de10cb5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components2/Manage/modal/DetailSheet.vue
// module id = dQ+q
// module chunks = 0